import React, { PureComponent } from 'react'
import { withRoutingTracker } from '../../HOC/withRoutingTracker.js'
import { connect } from 'react-redux'
import { addToCart, addYardsToCart, getFabricById } from '../../actions/generalActions.js'
import { PulseLoader } from 'react-spinners'
import { APP_URL } from '../../utils/config.js'
import { formatPrice, replaceEncodedAmpersand } from '../../utils/format.js'
import { addCanonical, sendGtag } from '../../utils/utils.js'
import { ReactComponent as BarCode } from '../../../assets/icons/bar-code.svg'
import { ReactComponent as Box } from '../../../assets/icons/box.svg'
import { ReactComponent as Price } from '../../../assets/icons/price.svg'
import { ReactComponent as Swatch } from '../../../assets/icons/swatch.svg'
import { ReactComponent as Material } from '../../../assets/icons/material.svg'
import { ReactComponent as Drop } from '../../../assets/icons/drop.svg'
import { ReactComponent as Medal } from '../../../assets/icons/medal.svg'
import { ReactComponent as Pattern } from '../../../assets/icons/pattern.svg'
import { ReactComponent as IndoorOutdoor } from '../../../assets/icons/indoor-outdoor.svg'
import { ReactComponent as Bath } from '../../../assets/icons/bath.svg'
import { ReactComponent as Arrow } from '../../../assets/icons/arrow.svg'
import Button from '../Templates/RedesignButton.js'
import Tippy from '@tippyjs/react'

class SingleFabric extends PureComponent {
  constructor(props) {
    super(props)

    const { general, fabrics, params } = props
    const { singleFabric: singleFabricId, singleCordFabric: singleCordFabricId } = general
    const fabricID = params.style ? singleCordFabricId : singleFabricId

    this.state = {
      isFavourite: !!(JSON.parse(localStorage.getItem('favourites')) || []).find(
        (fabricId) => fabricId === (params.style ? singleCordFabricId : singleFabricId),
      ),
      singleFabric: fabrics.filteredFabrics.find(
        (fabric) => fabric.id === (params.style ? singleCordFabricId : singleFabricId),
      ) || { id: null },
      isBuyingYards: false,
      isMobileBuyingYards: false,
      yardsQty: null,
      fabricID: fabricID || null,
    }
  }

  closeMobileBuyYardsModal = () => {
    this.setState({
      isMobileBuyingYards: false,
    })
  }

  closeBuyYardsModal = () => {
    this.setState({
      isBuyingYards: false,
    })
  }

  componentDidMount() {
    const { history } = this.props
    const { fabricID, singleFabric } = this.state

    if (singleFabric.id === null) {
      let fabric = fabricID
      if (fabricID === null) {
        fabric = history.location.search.split('=')[1]
      }
      getFabricById(fabric).then((res) => {
        this.setState({ singleFabric: res })
      })
    }

    sendGtag('view_item', null, {
      items: [
        {
          item_id: singleFabric?.sku ? singleFabric?.sku : `#${singleFabric?.id.toString()}`,
          item_name: singleFabric?.name,
        }
      ],
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { singleFabric } = this.state
    const { location, history, switchCurrentView } = this.props

    if (location !== prevProps.location && history.location.search === '') {
      switchCurrentView()
    }

    if (!prevState.singleFabric?.permalink && singleFabric?.permalink) {
      addCanonical(singleFabric.permalink)
    }
  }

  _getInfo = () => {
    const { singleFabric } = this.state
    const { fabrics } = this.props
    const { brands } = fabrics
    const info = {}

    singleFabric.attributes?.forEach((attribute) => {
      const key = attribute?.name
        ?.split(' ')
        .map((word) => word.toLowerCase())
        .join('_')
      info[key] = attribute?.options.join(', ')
    })

    info['sku'] = singleFabric.sku || '-'
    info['item_number'] = singleFabric.id
    info['price'] = parseFloat(singleFabric.regular_price).toFixed(2).toString() || '-'
    info['name'] = singleFabric.name
    info['cleaning'] =
      Object.values(brands).find((brand) => brand.name.toLowerCase() === info?.brand?.toLowerCase())
        ?.fabricsCare || '-'

    return info
  }

  addToCartCallback = () => {
    if (window?.increment_cart) {
      window.increment_cart()
    }
  }

  _buySwatch = () => {
    const { singleFabric } = this.state
    const { dispatch, fabrics } = this.props
    let cartKey = localStorage.getItem('cartKey')
    const fabricSku = singleFabric.attributes.find(
      (attr) => attr.name.toLowerCase() === 'internal sku',
    )?.options[0]
    const fabricColor = singleFabric.attributes.find(
      (attr) => attr.name.toLowerCase() === 'internal color number:',
    )?.options[0]
    const fabricBrand = singleFabric?.attributes?.find(
      (attr) => attr.name.toLowerCase() === 'brand',
    )?.options[0]
    const fabricName = singleFabric?.name
    const fabricMaterialName = singleFabric?.attributes
      ?.find((attr) => attr.name.toLowerCase() === 'material')
      ?.options[0].toLowerCase()
    const fabricMaterialID = fabrics.materials
      .map((material) => material.vals)
      .flat()
      .find((item) => item.name.toLowerCase() === fabricMaterialName)?.id

    const fabric = {
      type: 'fabric',
      is_swatch: true,
      pa_internal_sku: fabricSku,
      pa_attribute_brand: fabricBrand,
      pa_sku: singleFabric?.sku,
      pa_internal_color_number: fabricColor,
      pa_fabric_material: fabricMaterialID,
      product_name: fabricName,
    }

    sendGtag('buy_swatch_fabrics', singleFabric?.name)

    const info = Object.keys(singleFabric).length > 0 ? this._getInfo() : null

    sendGtag('add_to_cart', null, {
      currency: 'USD',
      value: parseFloat(formatPrice(info?.price_per_swatch).replace('$', '')),
      items: [
        {
          item_id: singleFabric?.sku,
          item_name: singleFabric?.name,
        },
      ],
    })

    dispatch(addToCart(cartKey, singleFabric, fabric, true, false, this.addToCartCallback))
  }

  _switchBack = () => {
    const { history } = this.props
    history.replace({ pathname: '/fabrics', search: '', state: { isActive: true } })
  }

  _toggleFavouriteFabric = (fabricId, fabricName) => () => {
    const currentFavourites = JSON.parse(localStorage.getItem('favourites')) || []
    if (currentFavourites.includes(fabricId)) {
      const newFavourites = currentFavourites.filter((id) => id !== fabricId)
      localStorage.setItem('favourites', JSON.stringify(newFavourites))
      this.setState({ isFavourite: false })
      sendGtag('favorites_fabrics', `${fabricName}_Favorite value 0`)
    } else {
      localStorage.setItem('favourites', JSON.stringify([...currentFavourites, fabricId]))
      this.setState({ isFavourite: true })
      sendGtag('favorites_fabrics', `${fabricName}_Favorite value 1`)
    }
  }

  _buyYardage = () => {
    this.setState({
      isBuyingYards: true,
    })
  }

  _buyMobileYardage = () => {
    this.setState({
      isMobileBuyingYards: true,
    })
  }

  _setQty = (e) => {
    this.setState({
      yardsQty: e.target.value !== '' ? Math.ceil(e.target.value).toString() : '',
    })
  }

  addYardsCallback = (yardsQty) => {
    if (window?.increment_cart && !isNaN(yardsQty)) {
      for (let i = 0; i < parseInt(yardsQty); i++) {
        window.increment_cart()
      }
    }
  }

  _addYardsToCart = () => {
    const { yardsQty, singleFabric } = this.state
    const { dispatch, general, fabrics } = this.props
    const { singleFabric: singleFabricId } = general
    const { filteredFabrics } = fabrics
    const foundFabrics = filteredFabrics?.find(
      (fabric) => fabric.id.toString() === singleFabricId?.toString(),
    )

    let cartKey = localStorage.getItem('cartKey')

    const fabricSku = foundFabrics?.attributes?.find(
      (attr) => attr.name.toLowerCase() === 'internal sku',
    )?.options[0]
    const fabricColor = foundFabrics?.attributes?.find(
      (attr) => attr.name.toLowerCase() === 'internal color number:',
    )?.options[0]
    const fabricBrand = foundFabrics?.attributes?.find(
      (attr) => attr.name.toLowerCase() === 'brand',
    )?.options[0]

    const fabric = {
      type: 'fabric',
      is_yardage: true,
      product_name: singleFabric?.slug,
      pa_internal_sku: fabricSku,
      pa_attribute_brand: fabricBrand,
      pa_sku: singleFabric?.sku || '',
      pa_internal_color_number: fabricColor,
      pa_fabric_material: foundFabrics?.attributes?.find(
        (attr) => attr.name.toLowerCase() === 'material',
      )?.options[0],
    }

    if (fabric && yardsQty) {
      sendGtag('buy_yardage_fabrics', `${singleFabric?.name}_Yardage quantity ${yardsQty?.toString()}`)

      const info = Object.keys(singleFabric).length > 0 ? this._getInfo() : null

      sendGtag('add_to_cart', null, {
        currency: 'USD',
        value: parseFloat(info?.price),
        items: [
          {
            item_id: singleFabric?.sku,
            item_name: singleFabric?.name,
            quantity: parseInt(yardsQty),
          },
        ],
      })

      dispatch(addYardsToCart(cartKey, singleFabric, fabric, yardsQty?.toString(), this.addYardsCallback))
    }
    setTimeout(() => {
      this.closeBuyYardsModal()
    }, 2500)
  }

  render() {
    const { singleFabric, isFavourite, isBuyingYards, isMobileBuyingYards, yardsQty } = this.state
    const { general } = this.props
    const { addingToCart, addingToCartYards, addedToCartMessages, addedToCartMessagesYards } =
      general

    const info = Object.keys(singleFabric).length > 0 ? this._getInfo() : null

    return (
      <div>
        <div className="single-fabric-header-wrapper">
          <div className="header-name-wrapper">
            <button
              id="back-to-results"
              className={'single-fabric-back-button'}
              type={'button'}
              onClick={this._switchBack}
            >
              <Arrow height={12} width={8} viewBox="0 0 8 12" />
            </button>
            <div className="header-title">{info.name}</div>
          </div>
          <div className="header-action-wrapper">
            <button
              className="favorite-button"
              type="button"
              onClick={this._toggleFavouriteFabric(singleFabric.id, singleFabric.name)}
            >
              <img
                id="favorite-img"
                className={`favourite-button ${isFavourite ? 'favourite-button-visible' : ''}`}
                src={`${APP_URL}/wp-content/uploads/2021/11/${isFavourite ? 'heart-full' : 'heart'}.svg`}
              />
            </button>
            <Tippy
              visible={isMobileBuyingYards}
              trigger="manual"
              placement="bottom"
              onClickOutside={this.closeMobileBuyYardsModal}
              interactive
              content={
                <div className="quantity-yards-container">
                  <div className="quantity-yards-label">Qty in yards:</div>
                  <div className="text-quantity-container">
                    <input
                      id="yards-qty"
                      className="quantity-input"
                      type="number"
                      min={1}
                      max={100}
                      value={yardsQty}
                      onChange={(e) => this._setQty(e)}
                    />
                  </div>
                  <Button id="add-yards-to-cart" onClick={this._addYardsToCart} variant="primary">
                    {addingToCartYards ? (
                      <PulseLoader color={'#FFFFFF'} size={8} />
                    ) : addedToCartMessagesYards[singleFabric.id] ? (
                      'Added To Cart'
                    ) : (
                      'Add to Cart'
                    )}
                  </Button>
                </div>
              }
              className="tooltip yards"
            >
              <div>
                <Button
                  id="add-yardage"
                  onClick={this._buyMobileYardage}
                  className={'single-fabric-buy-yardage-button'}
                >
                  Buy Yardage
                </Button>
              </div>
            </Tippy>
            <Button
              id="add-swatch"
              onClick={this._buySwatch}
              className={'single-fabric-buy-swatch-button'}
              variant="primary"
            >
              {addingToCart ? (
                <PulseLoader color={'#FFFFFF'} size={8} />
              ) : addedToCartMessages[singleFabric.id] ? (
                'Added To Cart'
              ) : (
                'Buy Swatch'
              )}
            </Button>
          </div>
        </div>
        {singleFabric.id !== null && (
          <div className={'single-fabric-container'}>
            <div className={'single-fabric-preview'}>
              <div className="single-fabric-wrapper">
                <img src={singleFabric?.images[0]?.src} />
              </div>
            </div>
            <div className="mobile-header-action-wrapper">
              <button
                className="favorite-button"
                type="button"
                onClick={this._toggleFavouriteFabric(singleFabric.id)}
              >
                <img
                  id="favorite-img"
                  className={`favourite-button ${isFavourite ? 'favourite-button-visible' : ''}`}
                  src={`${APP_URL}/wp-content/uploads/2021/11/${isFavourite ? 'heart-full' : 'heart'}.svg`}
                />
              </button>
              <Tippy
                visible={isBuyingYards}
                trigger="manual"
                placement="bottom"
                onClickOutside={this.closeBuyYardsModal}
                interactive
                content={
                  <div className="quantity-yards-container">
                    <div className="quantity-yards-label">Qty in yards:</div>
                    <div className="text-quantity-container">
                      <input
                        id="yards-qty"
                        className="quantity-input"
                        type="number"
                        min={1}
                        max={100}
                        value={yardsQty}
                        onChange={(e) => this._setQty(e)}
                      />
                    </div>
                    <Button id="add-yards-to-cart" onClick={this._addYardsToCart} variant="primary">
                      {addingToCartYards ? (
                        <PulseLoader color={'#FFFFFF'} size={8} />
                      ) : addedToCartMessagesYards[singleFabric.id] ? (
                        'Added To Cart'
                      ) : (
                        'Add to Cart'
                      )}
                    </Button>
                  </div>
                }
                className="tooltip yards"
              >
                <div>
                  <Button
                    id="add-yardage"
                    onClick={this._buyYardage}
                    className={'single-fabric-buy-yardage-button'}
                  >
                    Buy Yardage
                  </Button>
                </div>
              </Tippy>
              <Button
                id="add-swatch"
                onClick={this._buySwatch}
                className={'single-fabric-buy-swatch-button'}
                variant="primary"
              >
                {addingToCart ? (
                  <PulseLoader color={'#FFFFFF'} size={8} />
                ) : addedToCartMessages[singleFabric.id] ? (
                  'Added To Cart'
                ) : (
                  'Buy Swatch'
                )}
              </Button>
            </div>
            <div className={'single-fabric-details'}>
              <table>
                <tr>
                  <td>
                    <BarCode />
                  </td>
                  <td>
                    <span className="single-fabric-details-label">SKU Number:</span>
                    <span className="single-fabric-details-value">{info.sku}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Box />
                  </td>
                  <td>
                    <span className="single-fabric-details-label">Item Number:</span>
                    <span className="single-fabric-details-value">{info.item_number}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Price />
                  </td>
                  <td>
                    <span className="single-fabric-details-label">Price/yard:</span>
                    <span className="single-fabric-details-value">${info.price}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Swatch />
                  </td>
                  <td>
                    <span className="single-fabric-details-label">Swatch:</span>
                    <span className="single-fabric-details-value">
                      {formatPrice(info.price_per_swatch)}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Material />
                  </td>
                  <td>
                    <span className="single-fabric-details-label">Material:</span>
                    <span className="single-fabric-details-value">
                      {replaceEncodedAmpersand(info.material)}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Drop />
                  </td>
                  <td>
                    <span className="single-fabric-details-label">Color:</span>
                    <span className="single-fabric-details-value">
                      {replaceEncodedAmpersand(info.color)}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Medal />
                  </td>
                  <td>
                    <span className="single-fabric-details-label">Brand:</span>
                    <span className="single-fabric-details-value">
                      {replaceEncodedAmpersand(info.brand)}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Pattern />
                  </td>
                  <td>
                    <span className="single-fabric-details-label">Pattern:</span>
                    <span className="single-fabric-details-value">
                      {replaceEncodedAmpersand(info.pattern)}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <IndoorOutdoor />
                  </td>
                  <td>
                    <span className="single-fabric-details-label">Use:</span>
                    <span className="single-fabric-details-value">
                      {replaceEncodedAmpersand(info.use)}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Bath />
                  </td>
                  <td>
                    <span className="single-fabric-details-label">Cleaning:</span>
                    <span className="single-fabric-details-value">
                      {replaceEncodedAmpersand(info.cleaning)}
                    </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  general: state.general,
  fabrics: state.fabrics,
})

export default connect(mapStateToProps)(withRoutingTracker(SingleFabric))
